import { render, staticRenderFns } from "./ScoreAnswer.vue?vue&type=template&id=6e38ca4f&scoped=true&"
import script from "./ScoreAnswer.vue?vue&type=script&lang=js&"
export * from "./ScoreAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e38ca4f",
  null
  
)

export default component.exports